<template>
  <div class="audio-wrapper">
    <audio
      ref="audio"
      :src="src"
      @pause="onPause"
      @play="onPlay"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="onLoadedMetadata"/>

    <!-- 音频播放控件 -->
    <div class="audio-controls">
      <span class="btn" :class="[audio.playing ? 'btn-pause' : 'btn-play']" @click="startPlayOrPause"></span>
      <div class="sliderWrapper">
        <vue-slider v-model="audio.currentTime" :min="0" :max="audio.totalTime" @change="changeCurrentTime"></vue-slider>
        <div class="time">
          <span style="float:left;">{{ audio.currentTime | formatSecond }}</span>
          <span style="float:right;">{{ audio.totalTime | formatSecond }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from './VueSlider'

export default {
  name: 'VueAudio',
  components: {
    VueSlider
  },
  filters: {
    formatSecond (second = 0) {
      return realFormatSecond(second)
    }
  },
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      audio: {
        playing: false, // 音频是否处于播放状态
        currentTime: 0, // 音频当前播放时长
        totalTime: 0 // 音频总时长
      }
    }
  },
  methods: {
    // 控制音频的播放与暂停
    startPlayOrPause () {
      return this.audio.playing ? this.pause() : this.play()
    },
    // 播放音频
    play () {
      this.$refs.audio.play()
    },
    // 暂停音频
    pause () {
      this.$refs.audio.pause()
    },
    // 音频播放时的回调
    onPlay () {
      this.audio.playing = true
      this.$emit('onAudioPlay')
    },
    // 音频暂停时的回调
    onPause () {
      this.audio.playing = false
    },
    // timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeUpdate (res) {
      this.audio.currentTime = res.target.currentTime
    },
    // 加载音频流元数据完成后的回调
    onLoadedMetadata (res) {
      this.audio.totalTime = parseInt(res.target.duration)
    },
    // 进度条toolTip
    formatProcessToolTip (index = 0) {
      index = parseInt(this.audio.totalTime / 100 * index)
      return '当前: ' + realFormatSecond(index)
    },
    // 播放跳转
    changeCurrentTime (val) {
      this.$refs.audio.currentTime = val
    }
  }
}

function realFormatSecond (second) {
  var secondType = typeof second

  if (secondType === 'number' || secondType === 'string') {
    second = parseInt(second)

    var hours = Math.floor(second / 3600)
    second = second - hours * 3600
    var mimute = Math.floor(second / 60)
    second = second - mimute * 60

    if (hours > 0) {
      return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    } else {
      return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
    }
  } else {
    return '0:00:00'
  }
}
</script>

<style lang="stylus" scoped>
.audio-wrapper
  background-color #662C85
  height 100%
  display flex
  align-items center
  padding 0 15px
  .audio-controls
    height 34px
    display flex
    .btn
      width 34px
      height 34px
    .btn-play
      background url("~@/assets/images/icons/icon-audio-play.png") no-repeat center
      background-size 32px 32px
    .btn-pause
      background url("~@/assets/images/icons/icon-audio-pause.png") no-repeat center
      background-size 32px 32px
    .sliderWrapper
      width 275px
      margin-left 20px
      padding 5px 0
      position relative
      .time
        color #fff
        font-size 12px
        position absolute
        width 100%
        bottom 0
</style>
